import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import TextSnippetWrapper from 'components/TextSnippetWrapper';
import { RequiredValidation } from 'components/UI/RequiredValidation/RequiredValidation';

export default function NameComponent() {
  const {
    control,
    formState: { errors },
    setValue,
    watch,
  } = useFormContext();
  const showDescription = watch('showDescription');

  return (
    <div className="card-bg mb-4 p-3 workflow-section">
      <div className="mb-3 col-12 col-lg-6">
        <label className="form-label sub-title text-gray-500" htmlFor="name">
          Workflow Name <span className="text-danger">*</span>
        </label>
        <Controller
          name="workflow_title"
          rules={{ required: 'Workflow name is required' }}
          control={control}
          defaultValue=""
          render={({ field: { ref, ...fieldProps } }) => (
            <TextSnippetWrapper
              type="text"
              className="input-shadow w-100"
              placeholder="e.g., New Case Client Onboarding Workflow"
              ref={ref}
              {...fieldProps}
              autoComplete="off"
            />
          )}
        />
        <div className="form-text">Give your workflow a clear, descriptive name</div>
        <RequiredValidation errors={errors} field="workflow_title" message="Workflow name is required" />
      </div>

      <div className="mb-2">
        {!showDescription && (
          <span onClick={() => setValue('showDescription', true)}>
            <span className="text-muted fw-normal F-size13 cursor-pointer"> + Add Description (Optional)</span>
          </span>
        )}

        {showDescription && (
          <div>
            <div className="d-flex justify-content-between align-items-center mb-2">
              <label className="form-label fw-medium mb-0 cursor-pointer" htmlFor="description">
                Description
              </label>
              <i className="pi pi-times cursor-pointer" onClick={() => setValue('showDescription', false)} />
            </div>
            <Controller
              name="workflow_description"
              control={control}
              defaultValue=""
              render={({ field: { ref, ...fieldProps } }) => (
                <TextSnippetWrapper
                  type="textarea"
                  className="input-shadow w-100"
                  placeholder="e.g., This workflow automates the onboarding process for new case clients."
                  ref={ref}
                  {...fieldProps}
                  autoComplete="off"
                />
              )}
            />
            <div className="form-text">Help team members understand the purpose of this workflow</div>
          </div>
        )}
      </div>
    </div>
  );
}
